<template>
	<div>
		<ButtonClassic
			labelText="Labor Time Guide"
			@click="onFlatRateButtonClick"
			v-if="showButtons"
		/>
		<KiaFlatRateModal
			:vin="vin"
			:modelYear="modelYear"
			:modelName="modelName"
			:manufacturerId="manufacturerId"
			:visible="kiaFlatRateVisible"
			:companyId="companyId"
			@close="onFlatRateModalClose"
			@ready="onFlatRateModalReady"
			@import="onFlatRateImport"
		/>
	</div>
</template>

<script>
import pageMixin from '@/mixins/page-mixin';
import ButtonClassic from '@/components/forms/button/button-classic.vue';
import KiaFlatRateModal from '@/sections/service/labor-time-guide/kia-flat-rate/kia-flat-rate-modal.vue';
import messageHandlerMixin from '@/mixins/message-handler-mixin';
import Manufacturers from '@/constants/manufacturer-types';

export default {
	name: 'LaborTimeGuide',
	metaInfo() {
		return { title: 'Labor Time Guide' };
	},
	mixins: [pageMixin, messageHandlerMixin],
	components: {
		KiaFlatRateModal,
		ButtonClassic
	},
	data() {
		return {
			flatRateModalVisibleId: 0,
			modalData: undefined,
			flatRateModalReady: false
		};
	},
	props: {
		vin: {
			type: String,
			default: null
		},
		modelYear: {
			type: Number,
			default: null
		},
		modelName: {
			type: String,
			default: null
		},
		manufacturerId: {
			type: Number,
			default: null
		},
		/***
		 * tells page this is being iframed
		 */
		frame: {
			type: Boolean,
			default: true
		}
	},
	created() {
		if (!this.frame) {
			this.hidePageLoader();
		} else {
			this.sendPageReadyMessage();
		}

		this.showModal();
	},
	computed: {
		showButtons() {
			return !this.frame;
		},
		kiaFlatRateVisible() {
			return (
				this.flatRateModalVisibleId === Manufacturers.Kia ||
				this.flatRateModalVisibleId === Manufacturers.Acura
			);
		}
	},
	methods: {
		onModalMessage(message) {
			this.modalData = message.options;
			this.showModal();
		},
		showModal() {
			this.onFlatRateButtonClick();
		},
		sendPageReadyMessage() {
			this.postIFrameReadyMessageToAccess();
		},
		onFlatRateButtonClick() {
			this.flatRateModalVisibleId = this.manufacturerId;
		},
		onFlatRateModalClose() {
			this.sendCloseMessageToAccess();
			this.flatRateModalVisibleId = 0;
			this.hidePageLoader();
		},
		onFlatRateModalReady() {
			this.flatRateModalReady = true;
			this.hidePageLoader();
		},
		sendCloseMessageToAccess() {
			this.postCloseMessageToAccess();
		},
		onFlatRateImport(data) {
			this.postCustomEventMessageToAccess('flat-rate-import', data);
			this.onFlatRateModalClose();
		}
	}
};
</script>

<style lang="scss" scoped></style>
